var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { sm: "12" } },
        [
          _c("w-textarea-autogrow", {
            attrs: { label: _vm.$ct("description"), fancy: "" },
            model: {
              value: _vm.crm.Description,
              callback: function ($$v) {
                _vm.$set(_vm.crm, "Description", $$v)
              },
              expression: "crm.Description",
            },
          }),
          _c("w-select", {
            staticClass: "mts",
            attrs: {
              items: _vm.priorities,
              label: _vm.$ct("priority"),
              value: _vm.crm.Priority,
              fancy: "",
            },
            on: {
              input: function ($event) {
                _vm.crm.Priority = $event
              },
            },
          }),
          _c("app-crm-status", { attrs: { crm: _vm.crm } }),
          _c("app-crm-select-assigned", {
            staticClass: "mts",
            attrs: { crm: _vm.crm },
          }),
          _vm.crm.TimeSheduled
            ? _c(
                "w-link",
                {
                  staticClass: "mt",
                  on: {
                    click: function ($event) {
                      _vm.sheduleCrm = true
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mrs",
                    attrs: { icon: "calendar-alt" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$ct("shedule.sheduled-title")) +
                      " " +
                      _vm._s(_vm.sheduledTime) +
                      " "
                  ),
                ],
                1
              )
            : _c(
                "w-link",
                {
                  staticClass: "mt",
                  on: {
                    click: function ($event) {
                      _vm.sheduleCrm = true
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mrs",
                    attrs: { icon: "calendar-alt" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$ct("shedule.title"))),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.sheduleCrm,
            callback: function ($$v) {
              _vm.sheduleCrm = $$v
            },
            expression: "sheduleCrm",
          },
        },
        [
          _c("app-crm-shedule", {
            attrs: { crm: _vm.crm },
            on: {
              save: function ($event) {
                return _vm.save($event)
              },
              cancel: function ($event) {
                _vm.sheduleCrm = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }